import "./InfoGeneralCard.css";

const InfoGeneralCard = ({ imgSrc, spanTag, name, footerText, color, link, description, infoExtra}) => {
  return (
    <div className="card">
      <div className="card__inner">
        
        {/* Frente */}
        <div className="card__front">
          <div className="card__header">
            <h2 className="card-title">{name}</h2>
          </div>
          <div className="card__body">
            <img src={imgSrc} alt={name} />
            <span style={{ color: color }} className="card__body__date">
              {spanTag}
            </span>
          </div>
          <div style={{ backgroundColor: color }} className="card__footer">
            <div className="card__Footer__second">
              <p>{footerText}</p> 
            </div>
          </div>
        </div>

        {/* Dorso */}
        <div className="card__back" style={{ backgroundColor: color }}>
          <div className="card__back__content">
            <p>{description}</p>
            {infoExtra.map((info)=>(
                <p>{info}</p>
            ))}

            {link && 
            <a
                href={link.startsWith("http") ? link : `https://${link}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#d8d8d8ff", textDecoration: "underline" }}
                >
                Link de {name}
                </a>}
          </div>
        </div>

      </div>
    </div>
  );
};

export default InfoGeneralCard;